import { isFunction } from '@dimjs/lang';
import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from '../../modal';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../../utils';
import './style.less';

interface DialogSpinnerProps {
  message?: string;
  className?: string;
  hideMask?: boolean;
}

const ModalRender = (props: DialogSpinnerProps & BodyAppendDivElementProps) => {
  const [visible, setVisible] = useState(false);

  const onClose = hooks.useCallbackRef(() => {
    setVisible(false);
  });

  useEffect(() => {
    setVisible(true);
    window['dialogSpinnerClose'] = () => {
      setVisible(false);
    };
  }, []);

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${props.elementId}`);
  });

  return (
    <Modal
      {...props}
      visible={visible}
      getContainer={props.divElement}
      onClose={onClose}
      onAfterClose={onAfterClose}
      destroyOnClose={true}
      className={classNames('v-dialog-spinner', props.className)}
      mask={!props.hideMask}
      closeByMask={false}
    >
      <div className="v-dialog-spinner-icon"></div>
      <div className="v-dialog-spinner-message">{props?.message || '加载中'}</div>
    </Modal>
  );
};

export const dialogSpinner = {
  show: (props?: DialogSpinnerProps) => {
    const spinnerInst = document.querySelector('.v-dialog-spinner');
    if (spinnerInst) {
      return;
    }
    const { divElement, elementId } = bodyAppendDivElement();
    ReactDOM.render(<ModalRender {...props} divElement={divElement} elementId={elementId} />, divElement);
  },
  close: () => {
    const dialogSpinnerClose = window['dialogSpinnerClose'];
    if (dialogSpinnerClose && isFunction(dialogSpinnerClose)) {
      window['dialogSpinnerClose']();
      window['dialogSpinnerClose'] = null;
    } else {
      const element = document.querySelector('.v-dialog-spinner');
      if (element) {
        const elementParent = document.querySelector('.v-dialog-spinner')?.parentNode;
        document.body.removeChild(elementParent as Node);
      }
    }
  },
};
